var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGuterBrandschutz = function SvgGuterBrandschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.226,
    height: 82.962
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__f",
    x1: 37.321,
    x2: 39.362,
    y1: 78.085,
    y2: 3.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__g",
    x1: 48.072,
    x2: 53.697,
    y1: 67.144,
    y2: 15.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__b",
    x1: 27.993,
    x2: 19.086,
    y1: 69.846,
    y2: 8.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__a",
    x1: 62.294,
    x2: 62.405,
    y1: 36.272,
    y2: 36.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#f1710f",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f69b33",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__a",
    id: "guter-brandschutz_svg__h",
    x1: 62.211,
    x2: 62.217,
    y1: 36.111,
    y2: 36.108
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__a",
    id: "guter-brandschutz_svg__i",
    x1: 63.488,
    x2: 63.737,
    y1: 37.683,
    y2: 37.565
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__a",
    id: "guter-brandschutz_svg__j",
    x1: 62.668,
    x2: 62.932,
    y1: 36.776,
    y2: 36.651
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__a",
    id: "guter-brandschutz_svg__k",
    x1: 63.166,
    x2: 63.223,
    y1: 37.148,
    y2: 37.121
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__b",
    id: "guter-brandschutz_svg__l",
    x1: 43.512,
    x2: 59.099,
    y1: 60.767,
    y2: 6.398
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__m",
    x1: 38.944,
    x2: 38.944,
    y1: 65.272,
    y2: 15.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf3012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__c",
    x1: 40.058,
    x2: 36.993,
    y1: 88.66,
    y2: 56.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__c",
    id: "guter-brandschutz_svg__n",
    x1: 0.878,
    x2: 75.348,
    y1: 71.634,
    y2: 71.634
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__d",
    x1: 27.922,
    x2: 35.438,
    y1: 73.215,
    y2: 66.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0b2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brandschutz_svg__e",
    x1: 34.54,
    x2: 26.846,
    y1: 70.573,
    y2: 67.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__d",
    id: "guter-brandschutz_svg__o",
    x1: 40.804,
    x2: 48.321,
    y1: 73.215,
    y2: 66.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brandschutz_svg__e",
    id: "guter-brandschutz_svg__p",
    x1: 47.423,
    x2: 39.729,
    y1: 70.573,
    y2: 67.83
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__f)",
    d: "M38.719 80.436C16.805 79.87 3.819 64.38 7.625 40.383c1.49 5.96 1.16 9.6 8.939 16.881C10.109 44.521 2.66 24.825 42.549 0c0 0-2.5 9.878 7.491 22.921 7.388 10.806 8.469 24.862 5.216 33.138 8.78-3.934 5.743-22.14 5.743-22.14 20.26 16.29-.458 47.078-22.28 46.517"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__g)",
    d: "m67.724 45.484-.006-.006c-1.465 14.575-11.587 21.319-16.433 20.986-9.454-.65-1.74-10.308-4.633-19.863-1.187-3.91-4.022-7.413-6.65-10.461a25.76 25.76 0 0 1-4.819-9.77c-1.051-4.605.95-10.873.95-10.873a39.2 39.2 0 0 0-1.84 8.28 19.6 19.6 0 0 0 2.695 10.306c.24.4.494.79.75 1.181 2.308 3.476 4.59 6.802 5.246 11.02a17.93 17.93 0 0 1-1.3 9.75 29.3 29.3 0 0 1-6.506 9.106c-3.073 3.073-5.478 11.144 6.961 14.092a28.77 28.77 0 0 0 13.964-6.1 33.2 33.2 0 0 0 10.81-14.77 22.03 22.03 0 0 0 .811-12.878",
    opacity: 0.99
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__b)",
    d: "M35.178 65.14a29.3 29.3 0 0 0 6.506-9.106 19 19 0 0 0 .9-2.633 29 29 0 0 0-.532-6.728c-.623-4.025-3.369-7.095-5.487-10.403a21.8 21.8 0 0 1-3.877-11.341c-.048-4.947 2.512-9.403 2.822-14.27a6.34 6.34 0 0 0-.668-3.478 1 1 0 0 0-.387-.438c-.557-.284-1.89 1.134-2.306 1.458q-1.332 1.038-2.628 2.122a79 79 0 0 0-4.7 4.253 53.6 53.6 0 0 0-7.16 8.531 32.2 32.2 0 0 0-4.593 10.158c-2.147 8.91.804 16.548 4.312 23.474a.916.916 0 0 1-1.442 1.082c-5.448-5.1-7.045-8.494-7.988-12.056-.52 9.348 1.751 17.301 6.676 23.22 5.451 6.554 13.79 10.158 24.116 10.424q.284.007.566.007a23 23 0 0 0 2.822-.186c-12.428-2.95-10.024-11.018-6.952-14.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__a)",
    d: "M62.48 36.377q-.13-.132-.26-.262.13.13.26.262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__h)",
    d: "m62.22 36.115-.012-.01v-.002Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__i)",
    d: "M63.957 38.029"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__j)",
    d: "M63.12 37.05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__k)",
    d: "M63.269 37.22q-.074-.086-.149-.17z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__l)",
    d: "m67.726 45.484-.006-.006c-1.465 14.575-11.588 21.319-16.434 20.986-9.454-.65-1.74-10.308-4.632-19.863-1.187-3.91-4.022-7.412-6.65-10.461a24.1 24.1 0 0 1-5.374-10.672q-.178-.842-.335-1.69c-.003-3.723 4.925-18.615 7.089-22.064-.235 3.635.344 11.74 7.916 21.633a39.7 39.7 0 0 1 6.43 17.102c.747 5.594.262 11.12-1.325 15.164a.916.916 0 0 0 .851 1.25.9.9 0 0 0 .373-.079c7.388-3.31 7.086-15.42 6.58-20.68a22 22 0 0 1 1.748 1.925c.107.131.207.262.308.394a.04.04 0 0 1 .015.015c.308.403.601.812.87 1.23q.417.627.772 1.278l.018.03c.07.135.144.27.214.407.076.146.153.293.223.44q.11.222.21.445c.1.223.135.299.199.448a18 18 0 0 1 .525 1.374q.16.463.29.936.064.23.125.458"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__m)",
    d: "M36.3 15.387c-.443 2.217-1.036 4.405-1.305 6.612a18.9 18.9 0 0 0 .465 6.571 17.9 17.9 0 0 0 2.684 6.01 55 55 0 0 1 3.552 5.808 18.1 18.1 0 0 1 1.986 6.585 17.4 17.4 0 0 1-.746 6.82 26.1 26.1 0 0 1-7.57 11.155c3.07-3.277 5.775-7.031 6.967-11.332a17.9 17.9 0 0 0 .557-6.565 17.2 17.2 0 0 0-1.965-6.27c-1.012-1.979-2.309-3.805-3.531-5.714a18.8 18.8 0 0 1-2.736-6.305 16.3 16.3 0 0 1-.278-6.854 43 43 0 0 1 1.92-6.52"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__c)",
    d: "M70.66 82.879a95.7 95.7 0 0 0-65.095 0 1.536 1.536 0 0 1-1.963-1.17L.078 69.133a1.9 1.9 0 0 1 1.024-2.312 108.37 108.37 0 0 1 74.022 0 1.903 1.903 0 0 1 1.024 2.312L72.624 81.71a1.536 1.536 0 0 1-1.963 1.169"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__n)",
    d: "M71.132 81.945a.6.6 0 0 1-.212-.038 96.47 96.47 0 0 0-65.614 0 .6.6 0 0 1-.212.038.704.704 0 0 1-.657-.55L.913 68.818a.93.93 0 0 1 .045-.63.72.72 0 0 1 .405-.396 107.62 107.62 0 0 1 73.5 0 .72.72 0 0 1 .405.396.93.93 0 0 1 .045.63l-3.525 12.578a.704.704 0 0 1-.656.549"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__d)",
    d: "m31.933 64.223 1.394 2.826a.27.27 0 0 0 .202.146l3.118.453a.267.267 0 0 1 .148.456l-2.256 2.2a.27.27 0 0 0-.077.237l.533 3.106a.267.267 0 0 1-.388.282l-2.79-1.467a.27.27 0 0 0-.249 0L28.78 73.93a.267.267 0 0 1-.388-.282l.533-3.106a.27.27 0 0 0-.077-.237l-2.257-2.2a.267.267 0 0 1 .148-.456l3.119-.453a.27.27 0 0 0 .201-.147l1.395-2.825a.267.267 0 0 1 .48 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__e)",
    d: "M31.693 64.074a.26.26 0 0 1 .24.149l1.394 2.826a.27.27 0 0 0 .202.146l3.118.453a.267.267 0 0 1 .148.456l-2.256 2.2a.27.27 0 0 0-.077.237l.533 3.106a.267.267 0 0 1-.388.282l-2.79-1.467a.27.27 0 0 0-.249 0L28.78 73.93a.267.267 0 0 1-.388-.282l.533-3.106a.27.27 0 0 0-.077-.237l-2.257-2.2a.267.267 0 0 1 .148-.456l3.119-.453a.27.27 0 0 0 .201-.147l1.395-2.825a.26.26 0 0 1 .24-.15m0-.277a.54.54 0 0 0-.489.304l-1.394 2.826-3.112.448a.545.545 0 0 0-.301.929l2.256 2.2-.535 3.097a.544.544 0 0 0 .79.574l2.79-1.467 2.78 1.467a.544.544 0 0 0 .79-.574l-.533-3.106 2.254-2.191a.545.545 0 0 0-.302-.93l-3.118-.452L32.18 64.1a.54.54 0 0 0-.488-.304",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m28.59 73.916.533-3.106a.27.27 0 0 0-.077-.237l-.13-.126a.3.3 0 0 1 .008.094l-.533 3.106a.26.26 0 0 0 .203.298c0-.01-.005-.019-.003-.03M33.527 67.318a.27.27 0 0 0 .201.146l3.119.453c.008.001.013.008.02.01a.26.26 0 0 0-.22-.279l-3.118-.453a.3.3 0 0 1-.078-.032ZM26.938 67.917l3.119-.453a.27.27 0 0 0 .2-.146l1.396-2.826a.264.264 0 0 1 .354-.118l-.074-.151a.268.268 0 0 0-.48 0l-1.395 2.826a.27.27 0 0 1-.201.146l-3.119.453a.267.267 0 0 0-.148.456l.126.123a.265.265 0 0 1 .222-.31"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__o)",
    d: "m44.815 64.223 1.395 2.826a.27.27 0 0 0 .201.146l3.119.453a.267.267 0 0 1 .148.456l-2.257 2.2a.27.27 0 0 0-.077.237l.533 3.106a.267.267 0 0 1-.388.282l-2.79-1.467a.27.27 0 0 0-.248 0l-2.79 1.467a.267.267 0 0 1-.388-.282l.533-3.106a.27.27 0 0 0-.077-.237l-2.256-2.2a.267.267 0 0 1 .148-.456l3.118-.453a.27.27 0 0 0 .202-.146l1.394-2.826a.267.267 0 0 1 .48 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brandschutz_svg__p)",
    d: "M44.575 64.074a.26.26 0 0 1 .24.149l1.395 2.826a.27.27 0 0 0 .201.146l3.119.453a.267.267 0 0 1 .148.456l-2.257 2.2a.27.27 0 0 0-.077.237l.533 3.106a.267.267 0 0 1-.388.282l-2.79-1.467a.27.27 0 0 0-.248 0l-2.79 1.467a.267.267 0 0 1-.388-.282l.533-3.106a.27.27 0 0 0-.077-.237l-2.256-2.2a.267.267 0 0 1 .148-.456l3.118-.453a.27.27 0 0 0 .202-.147l1.394-2.825a.26.26 0 0 1 .24-.15m0-.277a.54.54 0 0 0-.488.304l-1.395 2.826-3.111.448a.545.545 0 0 0-.302.929l2.257 2.2L41 73.6a.544.544 0 0 0 .79.574l2.79-1.467 2.78 1.467a.544.544 0 0 0 .79-.574l-.532-3.106 2.253-2.191a.545.545 0 0 0-.301-.93l-3.119-.452-1.387-2.821a.54.54 0 0 0-.489-.304",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m41.473 73.916.533-3.106a.27.27 0 0 0-.077-.237l-.13-.126a.3.3 0 0 1 .007.094l-.533 3.106a.26.26 0 0 0 .203.298c.001-.01-.005-.019-.003-.03M46.41 67.318a.27.27 0 0 0 .2.146l3.12.453c.008.001.012.008.02.01a.26.26 0 0 0-.22-.279l-3.119-.453a.3.3 0 0 1-.078-.032ZM39.82 67.917l3.12-.453a.27.27 0 0 0 .2-.146l1.395-2.826a.264.264 0 0 1 .355-.118l-.075-.151a.268.268 0 0 0-.48 0l-1.394 2.826a.27.27 0 0 1-.202.146l-3.118.453a.267.267 0 0 0-.148.456l.125.123a.265.265 0 0 1 .223-.31"
  }))));
};
export default SvgGuterBrandschutz;